import React from "react";
import { useNavigate } from "react-router-dom";
import CodeAgentPanel from "./dashboard5/CodeAgentPanel";
import SideBar from "./SideBar";
import "./dashboard5/styles/dashboard5.css";
import "./CodeAgentPage.css";

/**
 * CodeAgentPage - Full page wrapper for Code Agent
 * Uses the same d5-root layout as TseDashboard5
 */
const CodeAgentPage = ({ onLogout, username }) => {
  const navigate = useNavigate();

  return (
    <div className="d5-root">
      <SideBar
        mode="code-triage"
        isDarkMode={false}
        onToggleTheme={() => {}}
        onLinkClick={(path) => navigate(path)}
        currentPath="/code-agent"
      />
      <div className="d5-main">
        <CodeAgentPanel username={username} />
      </div>
    </div>
  );
};

export default CodeAgentPage;
